import React, { useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { Search, X } from "lucide-react";
import CollapsibleItemsList from "../../ui/CollapsibleItemsList.tsx";

interface Profile {
  profile_id: string;
  backend_config: {
    collections: string[];
    prompt: Array<[string, string]>;
  };
}

interface ProfileExistingListProps {
  profiles: Profile[];
  isLoading: boolean;
  expanded: boolean;
  onToggleExpanded: () => void;
  onEditProfile: (profile: Profile) => void;
  onDeleteProfile: (profileId: string) => Promise<void>;
  isDarkMode: boolean;
  totalProfiles?: number;
  searchProfileId?: string;
  onSearchByProfile?: (profileId: string) => void;
  onClearSearch?: () => void;
}

const ProfileExistingList = ({
  profiles,
  isLoading,
  expanded,
  onToggleExpanded,
  onEditProfile,
  onDeleteProfile,
  isDarkMode,
  totalProfiles,
  searchProfileId,
  onSearchByProfile,
  onClearSearch
}: ProfileExistingListProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [textConfig, setTextConfig] = useState<any>({});
  const [localSearchProfileId, setLocalSearchProfileId] = useState(searchProfileId || "");

  const fetchTextConfig = async () => {
    try {
      const response = await fetch("/text.json");
      const data = await response.json();
      setTextConfig(data);
    } catch (error) {
      console.error("Error loading text config:", error);
    }
  };

  useEffect(() => {
    fetchTextConfig();
  }, []);

  useEffect(() => {
    setLocalSearchProfileId(searchProfileId || "");
  }, [searchProfileId]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearchByProfile && localSearchProfileId.trim()) {
      onSearchByProfile(localSearchProfileId.trim());
    }
  };

  const handleClearSearch = () => {
    setLocalSearchProfileId("");
    if (onClearSearch) {
      onClearSearch();
    }
  };

  const renderProfileItem = (profile: Profile, index: number) => (
    <div className="flex items-center min-w-0 flex-1">
      <span className={`text-sm font-medium truncate ${
        isDarkMode ? "text-white" : "text-black"
      }`}>
        {profile.profile_id}
      </span>
      <span className={`ml-2 text-xs flex-shrink-0 ${
        isDarkMode ? "text-gray-400" : "text-gray-700"
      }`}>
        {profile.backend_config?.collections?.length || 0} colección(es)
      </span>
    </div>
  );

  return (
    <div className="mt-4">
      {/* 
      <div className="mb-4 space-y-3">
        <form onSubmit={handleSearch} className="space-y-3">
          <div>
            <label 
              htmlFor="profile-search" 
              className={`block text-sm font-medium mb-2 ${
                isDarkMode ? "text-gray-300" : "text-gray-700"
              }`}
            >
              {textConfig.PROFILE_EXISTING_LIST_SEARCH_LABEL || "Buscar por perfil"}
            </label>
            <div className="relative">
              <input
                id="profile-search"
                type="text"
                value={localSearchProfileId}
                onChange={(e) => setLocalSearchProfileId(e.target.value)}
                placeholder={textConfig.PROFILE_EXISTING_LIST_SEARCH_PLACEHOLDER || "Ingrese el ID del perfil..."}
                className={`w-full px-3 py-2 pl-10 rounded-md border-2 border-[#1BCF66] transition-colors ${
                  isDarkMode 
                    ? "bg-[#2D2D2D] text-white placeholder-gray-400 focus:border-[#1BCF66] focus:ring-1 focus:ring-[#1BCF66]" 
                    : "bg-white text-gray-900 placeholder-gray-500 focus:border-[#1BCF66] focus:ring-1 focus:ring-[#1BCF66]"
                }`}
              />
              <Search 
                size={16} 
                className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${
                  isDarkMode ? "text-gray-400" : "text-gray-500"
                }`} 
              />
            </div>
          </div>
          <div className="flex gap-2">
            <button
              type="submit"
              disabled={!localSearchProfileId.trim()}
              className={`px-4 py-2 rounded-md transition-colors ${
                localSearchProfileId.trim()
                  ? "bg-[#1BCF66] text-white hover:bg-[#1BCF66]/90"
                  : "bg-gray-400 text-gray-600 cursor-not-allowed"
              }`}
            >
              {textConfig.PROFILE_EXISTING_LIST_SEARCH_BUTTON || "Buscar"}
            </button>
            {(localSearchProfileId.trim()) && (
              <button
                type="button"
                onClick={handleClearSearch}
                className={`flex items-center gap-1 px-3 py-2 rounded-md text-sm transition-colors ${
                  isDarkMode 
                    ? "text-gray-400 hover:text-white border border-gray-600 hover:border-gray-500" 
                    : "text-gray-600 hover:text-gray-900 border border-gray-300 hover:border-gray-400"
                }`}
              >
                <X size={14} />
                {textConfig.PROFILE_EXISTING_LIST_CLEAR_BUTTON || "Limpiar"}
              </button>
            )}
          </div>
        </form>
      </div>
      */}

      <CollapsibleItemsList
        items={profiles}
        isLoading={isLoading}
        isDarkMode={isDarkMode}
        itemsExpanded={expanded}
        setItemsExpanded={onToggleExpanded}
        onDelete={onDeleteProfile}
        onEdit={onEditProfile}
        type="profile"
        title={textConfig.PROFILE_EXISTING_LIST_TITLE || "Perfiles Existentes"}
        emptyMessage={textConfig.PROFILE_EXISTING_LIST_EMPTY || "No hay perfiles disponibles"}
        loadingMessage={textConfig.PROFILE_EXISTING_LIST_LOADING || "Cargando perfiles..."}
        totalCount={totalProfiles}
        renderItem={renderProfileItem}
        showDeleteButton={true}
      />
    </div>
  );
};

export default ProfileExistingList;